import { render, staticRenderFns } from "./TaxesCommerceAccountList.vue?vue&type=template&id=7112b3aa&"
import script from "./TaxesCommerceAccountList.vue?vue&type=script&lang=js&"
export * from "./TaxesCommerceAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports